"use client";
import { FormMultiSelect, FormSingleSelect, FormCheckbox, FormTextArea, FormTextField } from "./internal/components.js";
function formInputs() {
  const TextField = FormTextField;
  const TextArea = FormTextArea;
  const Checkbox = FormCheckbox;
  const SingleSelect = FormSingleSelect;
  const MultiSelect = FormMultiSelect;
  return {
    TextField,
    TextArea,
    Checkbox,
    SingleSelect,
    MultiSelect
  };
}
export {
  formInputs
};
